import { ref, computed } from "vue";

export const PROGRESS_MAX = 1000;
export const PROGRESS_STEP = 20;
export const PROGRESS_INTERVAL = 10;

export function useProgressAnimation() {
  const timer = ref<NodeJS.Timeout | null>(null);
  const progress = ref(0);

  const isProgressAnimationActive = computed(() => {
    return progress.value > 0 && progress.value < PROGRESS_MAX;
  });

  const startProgressAnimation = () => {
    progress.value = 0;
    if (timer.value) clearInterval(timer.value);
    timer.value = setInterval(() => {
      if (progress.value < PROGRESS_MAX) {
        progress.value += PROGRESS_STEP;
      } else {
        stopProgressAnimation();
      }
    }, PROGRESS_INTERVAL);
  };

  const stopProgressAnimation = () => {
    if (timer.value) clearInterval(timer.value);
    progress.value = PROGRESS_MAX;
  };

  return {
    animationProgress: progress,
    isProgressAnimationActive,
    startProgressAnimation,
  };
}
